import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonSetItem } from './app-button-set-models';

@Component({
    selector: 'app-button-set',
    templateUrl: './app-button-set.component.html',
    styleUrls: ['./app-button-set.component.css'],
    standalone: false
})
export class AppButtonSetComponent {
  @Input() buttons!: ButtonSetItem[];
  @Output() select: EventEmitter<ButtonSetItem> =
    new EventEmitter<ButtonSetItem>();

  onClick(event: any) {
    this.select.emit(event);
    this.buttons.forEach(
      (btn) => (btn.active = btn.value === event.value ? true : false)
    );
  }
}
